if (!customElements.get('review-quotes')) {
  class ReviewQuotes extends HTMLElement {
    connectedCallback() {
      this.filters = [...this.querySelectorAll('[data-filter]')];
      this.slides = [...this.querySelectorAll('[data-tag]')];
      this.status = this.querySelector('[data-filter-status]');
      this.statusTemplate = this.querySelector('[data-filter-status-template]')?.innerHTML ?? '';
      this.carousel = this.querySelector('scroll-carousel');

      this.onFilterClick = this.handleFilterClick.bind(this);

      for (const filter of this.filters) {
        filter.addEventListener('click', this.onFilterClick);
      }
    }

    disconnectedCallback() {
      for (const filter of this.filters ?? []) {
        filter.removeEventListener('click', this.onFilterClick);
      }
    }

    /**
     * Shows only the quotes whose tag matches the pressed filter; an empty filter shows all.
     * @param {MouseEvent} event
     * @returns {void}
     */
    handleFilterClick(event) {
      const activeFilter = event.currentTarget;
      const tag = activeFilter.dataset.filter;
      let visibleCount = 0;

      for (const filter of this.filters) {
        filter.setAttribute('aria-pressed', String(filter === activeFilter));
      }

      for (const slide of this.slides) {
        const isVisible = !tag || slide.dataset.tag === tag;
        slide.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      }

      this.carousel?.reset();

      if (this.status) this.status.textContent = this.statusTemplate.replace('[number]', String(visibleCount));
    }
  }

  customElements.define('review-quotes', ReviewQuotes);
}
